// extracted by mini-css-extract-plugin
export default {"shirtHelpText":"RegistrationProfile_shirtHelpText__auDVT","profilePicMedia":"RegistrationProfile_profilePicMedia__Ox8jo"};